var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocumtenensComLogoMarkWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 311.507,
    height: 271.563,
    viewBox: "0 0 311.507 271.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    opacity: 0.102
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LT_Icon",
    "data-name": "LT Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M266.9,43.663l-21.29-21.294a1.369,1.369,0,0,0-1.922,0L84.654,181.41l-20-20.008-1.3-1.3L44.711,141.463a2.209,2.209,0,0,0-3.121,0L21.65,161.4a2.205,2.205,0,0,0,0,3.128l18.629,18.629,1.31,1.307,32.072,32.069,10.187,10.187a1.358,1.358,0,0,0,1.919,0l.418-.418a2.2,2.2,0,0,0,.221-.145L128.1,184.466l1.31-1.3,16.437-16.444,2.2-2.188,15.549-15.556,2.192-2.2,17.747-17.744a2.2,2.2,0,0,0,.145-.221l83.23-83.23A1.362,1.362,0,0,0,266.9,43.663Z",
    transform: "translate(-21 -21.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M226.772,163.435,129.041,65.7a1.595,1.595,0,0,0-2.067,0L45.919,146.759a1.362,1.362,0,0,0,0,1.922l21.294,21.294a1.365,1.365,0,0,0,1.919,0L128.008,111.1l75.549,75.549a1.362,1.362,0,0,0,1.922,0l21.294-21.294A1.364,1.364,0,0,0,226.772,163.435Z",
    transform: "translate(39.247 84.519)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M197.693,193.445,121.546,117.3l58.828-58.831a1.358,1.358,0,0,0,0-1.919l-21.29-21.294a1.362,1.362,0,0,0-1.922,0L76.106,116.314a1.428,1.428,0,0,0,0,1.97l98.374,98.374a1.358,1.358,0,0,0,1.919,0l21.294-21.294A1.358,1.358,0,0,0,197.693,193.445Z",
    transform: "translate(113.418 9.677)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocumtenensComLogoMarkWhite);
export default __webpack_public_path__ + "static/media/locumtenens_com_logo_mark--white.6a63004cecc21c4c6bef4daca73579ee.svg";
export { ForwardRef as ReactComponent };